var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chip form-control-alternative"},[_vm._t("default"),_c('i',{staticClass:"fa fa-times delete-icon",on:{"click":function($event){return _vm.$emit('onDelete')}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }